import { db } from "../Config";

export const fetchDeudores = async (empresaId) => {
  let deudores = [];
  try {
    const querySnapshot = await db
      .collection("empresas")
      .doc(empresaId)
      .collection("pacientes")
      .where("cuenta.adeudado", ">", 0)
      .get();

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      deudores.push({
        pacienteId: doc.id,
        adeudado: data.cuenta?.adeudado || 0,
        abonado: data.cuenta?.saldo || 0,
        paciente: {
          nombres: data.nombres,
          apellidos: data.apellidos,
          telefono: data.telefono,
        },
      });
    });
  } catch (err) {
    console.error("Error fetching debtors:", err);
    throw new Error(err);
  }
  return deudores;
};

// fetch pacientes deududores de una empresa
export const fetchDeudoresByEmpresa = async (empresaId) => {
  try {
   const pacintesSnapshot = await db
      .collection("empresas")
      .doc(empresaId)
      .collection("pacientes")
      .where("cuenta.adeudado", ">", 0)
      .get();

    const deudores = pacintesSnapshot.docs.map((doc) => {
      const data = doc.data();
      return { 
        pacienteId: doc.id,
        adeudado: data.cuenta?.adeudado || 0,
        abonado: data.cuenta?.saldo || 0,
        
          nombres: data.nombres,
          apellidos: data.apellidos,
          telefono: data.telefono
      }
    });
    return deudores;
  }   catch (err) {
    console.error("Error fetching debtors:", err);
    throw new Error(err);
  }
};
